import { render } from "./ActionSendPushNotification.vue?vue&type=template&id=13c81b90"
import script from "./ActionSendPushNotification.vue?vue&type=script&lang=ts"
export * from "./ActionSendPushNotification.vue?vue&type=script&lang=ts"
script.render = render

export default script